import { FC } from "react";

import { Layout } from "antd";

import DashboardHeader from "./header/DashboardHeader";
import Sidebar, { SidebarProvider } from "./sidebar/Sidebar";
import RouteList from "../../routes/routeList";

const { Content } = Layout;

const DashboardLayout: FC = () => (
  <SidebarProvider>
    <Layout>
      <Sidebar />
      <Layout>
        <DashboardHeader />
        <Content style={{ minHeight: "90vh" }}>
          <RouteList />
        </Content>
      </Layout>
    </Layout>
  </SidebarProvider>
);

export default DashboardLayout;
